import { useEffect, useState } from "react";
import { getDetailedChanges } from "shared/utils/getUpdatedFields";

interface FormChangeTrackerProps<T> {
  values: T;
  initialValues: T;
  onFormChange: (hasChanges: boolean) => void;
}

export const FormChangeTracker = <T extends Record<string, any>>({
  values,
  initialValues,
  onFormChange,
}: FormChangeTrackerProps<T>) => {
  const [lastHasChanges, setLastHasChanges] = useState(false);

  useEffect(() => {
    const { hasChanges } = getDetailedChanges(
      initialValues as Record<string, any>,
      values as Record<string, any>
    );

    if (hasChanges !== lastHasChanges) {
      setLastHasChanges(hasChanges);
      onFormChange(hasChanges);
    }
  }, [values, initialValues, onFormChange, lastHasChanges]);

  return null;
};
